import React, { ReactNode } from 'react'

import { StyledCardAuthor, StyledUtility, StyledWrapper } from './index.styled'

type Props = {
  authorProps: any
  children?: ReactNode
}

const CardAuthorWrapper = ({ authorProps, children, ...rest }: Props) => {
  return (
    <StyledWrapper {...rest}>
      <StyledCardAuthor
        {...authorProps}
        profileModalProps={{
          zIndex: 1000,
        }}
        profileProps={{
          hideQuestionTab: true,
          showSkipQuestionTag: true,
          rolesToShowQuestionsTab: ['expert', 'moderator'],
        }}
        extendEle={<StyledUtility>{children}</StyledUtility>}
      />
    </StyledWrapper>
  )
}

export { CardAuthorWrapper }
